import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ROUTE_TRANSLATION_MODULES, TranslationModule } from './i18n.config';
import { TranslationManagerService } from './translation-manager.service';

/**
 * Автоматично підтягує модулі перекладу під поточний роут.
 *
 * Завдяки цьому фіча-компоненти в більшості випадків не мусять нічого робити руками:
 * перехід на `/crm/olx/...` сам по собі гарантує наявність неймспейсів `olx.*`.
 * Явний виклик `loadModuleTranslations()` лишається для позамаршрутних UI
 * (глобальні сайдбари, модалки), які відкриваються поверх будь-якого екрана.
 */
@Injectable({ providedIn: 'root' })
export class TranslationRouteService {
  private readonly router = inject(Router);
  private readonly manager = inject(TranslationManagerService);

  private started = false;

  public start(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    this.loadForUrl(this.router.url);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.loadForUrl(event.urlAfterRedirects || event.url));
  }

  private loadForUrl(url: string): void {
    const modules = this.modulesForUrl(url);
    if (modules.length) {
      this.manager.loadModules(modules).subscribe();
    }
  }

  private modulesForUrl(url: string): TranslationModule[] {
    const path = (url || '').split('?')[0];
    const matched = new Set<TranslationModule>();

    for (const [prefix, modules] of Object.entries(ROUTE_TRANSLATION_MODULES)) {
      if (path.startsWith(prefix)) {
        modules.forEach((module) => matched.add(module));
      }
    }

    return [...matched];
  }
}
